import { useEffect, useRef, useState } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { translator, LANGS } from "@/lib/translator";

export default function LanguageSwitcher({ mobile = false }) {
  const [lang, setLang] = useState(translator.getStoredLang());
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onChange = (e) => setLang(e.detail);
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    window.addEventListener("dds-lang-changed", onChange);
    document.addEventListener("mousedown", onClick);
    return () => {
      window.removeEventListener("dds-lang-changed", onChange);
      document.removeEventListener("mousedown", onClick);
    };
  }, []);

  const pick = (code) => {
    setOpen(false);
    translator.setLanguage(code);
  };

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  if (mobile) {
    return (
      <div className="flex items-center justify-center gap-2 pt-3" data-no-translate data-testid="lang-switcher-mobile">
        {LANGS.map((l) => (
          <button
            key={l.code}
            onClick={() => pick(l.code)}
            data-testid={`lang-mobile-${l.code}`}
            className={`px-3 py-2 rounded-xl border font-headings font-bold text-sm ${
              l.code === lang ? "border-[#00a86b] text-[#00a86b] bg-[#00a86b]/5" : "border-[#1a2332]/15 text-[#1a2332]/70"
            }`}
          >
            {l.flag} {l.code.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="relative" ref={ref} data-no-translate data-testid="lang-switcher">
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-btn"
        aria-label="Changer de langue"
        className="flex items-center gap-1.5 border border-[#1a2332]/15 hover:border-[#00a86b] hover:text-[#00a86b] text-[#1a2332]/80 font-headings font-bold rounded-xl px-3 py-2.5 text-sm transition-colors"
      >
        <Globe className="w-4 h-4" />
        {current.code.toUpperCase()}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-black/10 rounded-xl shadow-xl overflow-hidden z-50" data-testid="lang-dropdown">
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => pick(l.code)}
              data-testid={`lang-option-${l.code}`}
              className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm font-headings font-semibold text-left transition-colors ${
                l.code === lang ? "bg-[#00a86b]/8 text-[#00a86b]" : "text-[#1a2332] hover:bg-black/5"
              }`}
            >
              <span>{l.flag}</span> {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
